import cx from 'clsx';

import styles from 'theme/features/dashboard/dashboard-business-unit.module.scss';

const SectionHeader = ({ businessUnitName, withSubtitle = false }) => (
  <div>
    <p className={styles['header-title']}>
      BU Program Breakdown
      {businessUnitName && <span> | {businessUnitName}</span>}
    </p>
    <p className={cx(styles['header-subtitle'], !withSubtitle && styles['header-subtitle--hidden'])}>
      Workplace Area Percentage
    </p>
  </div>
);

export default SectionHeader;
